export default __webpack_public_path__ + "static/media/patients.573f01ab.svg";